import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    intervideoInvites: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_INTERVIDEOINVITE_SELECT_IDS (store, ids) {
      store.intervideoInvites.selectIds = ids
    },
    REMOVE_INTERVIDEOINVITE_SELECT_IDS (store, ids) {
      store.intervideoInvites.selectIds = store.intervideoInvites.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_INTERVIDEOINVITE_SELECT_ID (store, id) {
      store.intervideoInvites.selectId = id
    },
    SET_INTERVIDEOINVITE_FILTERS (store, filters) {
      store.intervideoInvites.filters = filters
    },
    SET_INTERVIDEOINVITE_PAGINATE (store, val) {
      store.intervideoInvites.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getIntervideoInvites: (store, getters) => {
      return store.intervideoInvites.selectIds.map((id) => {
        return getters['entities/intervideoInvites/find'](id)
      })
    },
    getIntervideoInvitesFilters: (store, getters) => {
      return store.intervideoInvites.filters
    },
    getIntervideoInvitesPaginate: (store, getters) => {
      return store.intervideoInvites.paginate
    },
    getIntervideoInvite: (store, getters) => {
      return getters['entities/intervideoInvites/find'](store.intervideoInvites.selectId) || {}
    }
  },
  actions: {
    /*
    selectIntervideoInvites
    */
    selectIntervideoInvites ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntervideoInvites', filters)
      .then((response) => {
        commit('SET_INTERVIDEOINVITE_FILTERS', filters)
        commit('SET_INTERVIDEOINVITE_PAGINATE', response)
        commit('SET_INTERVIDEOINVITE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectIntervideoInvites
    */
    refreshSelectIntervideoInvites ({commit, dispatch, getters, state}) {
      return dispatch('selectIntervideoInvites', getters.getIntervideoInvitesFilters)
    },
    /*
    selectIntervideoInvite
    */
    selectIntervideoInvite ({commit, dispatch, getters, state}, id) {
      return dispatch('getIntervideoInviteById', id)
      .then((response) => {
        commit('SET_INTERVIDEOINVITE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getIntervideoInvites
    */
    getIntervideoInvites ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideo-invites`, {params: filters})
      .then((response) => {
        return dispatch('entities/intervideoInvites/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.intervideoInvites || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getIntervideoInviteById
    */
    getIntervideoInviteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideo-invites/${id}`)
      .then((response) => {
        return dispatch('entities/intervideoInvites/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.intervideoInvites[0]
      })
    },
    /*
    createIntervideoInvite
    */
    createIntervideoInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/intervideo-invites`, data)
      .then((response) => {
        return dispatch('entities/intervideoInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervideoInvites[0]
      })
    },
    /*
    updateIntervideoInvite
    */
    updateIntervideoInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/intervideo-invites/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/intervideoInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervideoInvites[0]
      })
    },
    /*
    deleteIntervideoInvite
    */
    deleteIntervideoInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/intervideo-invites/${id}`)
      .then((response) => {
        commit('REMOVE_INTERVIDEOINVITE_SELECT_IDS', [id])
        dispatch('entities/intervideoInvites/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/IntervideoInvite.js